import React from 'react';
import { Stack, CircularProgress, Box } from '@mui/material';

const INDIGO = '#4F46E5';

function BoxLoader({ loading }) {
  if (!loading) return null;
  return (
    <Stack
      sx={{
        backgroundColor: 'rgba(248, 250, 252, 0.80)',
        backdropFilter: 'blur(4px)',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
        borderRadius: 'inherit',
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* Outer faint ring */}
        <CircularProgress
          size={44}
          thickness={2}
          sx={{ color: 'rgba(79,70,229,0.15)', position: 'absolute' }}
          variant="determinate"
          value={100}
        />
        {/* Main spinner */}
        <CircularProgress
          size={44}
          thickness={3.5}
          sx={{ color: INDIGO }}
        />
      </Box>
    </Stack>
  );
}

export default BoxLoader;
